__turbopack_context__.v({
  "className": "figtree_d36c8178-module__O2xE3q__className",
});
